import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { createSession } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/farmway-logo.png';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    (async () => {
      if (!sid) {
        navigate('/login', { replace: true });
        return;
      }
      try {
        const res = await createSession(sid);
        setUser(res.user);
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user: res.user } });
      } catch (e) {
        navigate('/login', { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="grid min-h-screen place-items-center bg-farmway-green text-farmway-cream">
      <div className="flex flex-col items-center gap-4">
        <img src={logo} alt="" className="h-14 w-14 animate-pulse rounded-xl" />
        <p className="font-display text-sm uppercase tracking-[0.3em] text-farmway-cream/70">Signing you in…</p>
      </div>
    </div>
  );
}
